import React, { useCallback, useState } from 'react';
import { Col, Row, Card, message } from 'antd';
import { token, lang, baseURL } from '../../api/config';
import '../../assets/iconfont.css';
import styles from './index.module.less';

const buildDownloadUrl = (series_id, key, isDeveloperTools) => {
  const baseUrl = `${baseURL}/api/plm/product/series/${series_id}/release-notes.md`;
  const params = new URLSearchParams({
    access_token: token,
    mode: 'inline',
    lang: lang,
  });

  if (isDeveloperTools) {
    params.append('category', 'DeveloperTools');
    params.append('subcategory', key);
  } else {
    params.append('category', 'firmware');
  }

  return `${baseUrl}?${params.toString()}`;
};

// 兼容两种数据格式：
// 1. 原始格式：{ doc_id: name }
// 2. 对象格式：{ doc_id: "xxx", file_name: "zzz" }
const resolveChangelogItem = (item) => {
  if (item.doc_id !== undefined && typeof item.doc_id === 'string') {
    // 对象格式
    return {
      key: item.doc_id,
      value: item.file_name || ''
    };
  }
  // 原始格式：{ doc_id: name }
  const key = Object.keys(item)[0];
  const value = item[key];
  return { key, value };
};

export default function ChangeLog({
  changelogs = [],
  isDeveloperTools = false,
  category,
  series_id,
}) {
  const [downloading, setDownloading] = useState({});

  const handleDownload = useCallback(async (key, value, item) => {
    if (downloading[key]) return;

    setDownloading(prev => ({ ...prev, [key]: true }));
    try {
      const changelogSeriesId = isDeveloperTools ? series_id : key;
      const response = await fetch(buildDownloadUrl(encodeURIComponent(changelogSeriesId), key, isDeveloperTools));
      if (!response.ok) throw new Error('Download failed');

      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${value}_CHANGELOG.md`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading file:', error);
      message.error('Failed to download changelog');
    } finally {
      setDownloading(prev => ({ ...prev, [key]: false }));
    }
  }, [series_id, isDeveloperTools]);

  return (
    <div className="singular-row">
      <Row gutter={[20, 20]}>
        {changelogs.map((item, index) => {
          const { key, value } = resolveChangelogItem(item);
          return (
            <Col key={key || index} span={6}>
              <Card className={downloading[key] ? styles.downloading : ''}>
                <div className="card-content">
                  <div className="card-content-left">
                    <div className={styles.file_title}>
                      {`${value}_CHANGELOG`}
                    </div>
                  </div>
                  <div className="download">
                    <i
                      className={`iconfont icon-download ${downloading[key] ? styles.disabled : ''}`}
                      onClick={() => handleDownload(key, value, item)}
                    />
                  </div>
                </div>
              </Card>
            </Col>
          );
        })}
      </Row>
    </div>
  );
}
